import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { SITE_NAME, PUBLISHER_BLOCKING, VIDEO_BID_MODIFICATION } from '../../fields';
import { SITE_VIDEO_REPORT_ID } from './siteVideoReportId';

const siteReportFooterColumnDefinition = [SITE_NAME, PUBLISHER_BLOCKING, VIDEO_BID_MODIFICATION].map(
    createFooterMapper(SITE_VIDEO_REPORT_ID)
);

export default siteReportFooterColumnDefinition;
